const languages = [];

// Modify the file "public/languages/languages.json"

export default class { static languages = languages }
